import React from 'react';

// Constants
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

// Types
import { ReferencePatternName } from 'Shared/types/BaInfo.types';

// Components
import RelationshipSampleGraph from './RelationshipSampleGraph/RelationshipSampleGraph';
import RelationshipSamplePerson from './RelationshipSamplePerson/RelationshipSamplePerson';
import { WpButton } from 'Wpds/components/button';
import { WpContainer, WpContainerBody } from 'Wpds/components/container';
import { WpIcon } from 'Wpds/components/icon';
import { WpLink } from 'Wpds/components/link';
import { WpDivider } from 'Wpds/components/divider';
import { WpText } from 'Wpds/components/text';

// Hooks
import { useApp } from 'Shared/utils/hooks/use-app';
import { usePITracking } from 'Shared/tracking/use-pi-tracking';

import './RelationshipSample.scss';

const RelationshipSample = () => {
  const { intercomContactSalesEventName } = useApp();
  const { trackLearnMoreInspireBasicsClick } = usePITracking();
  // Constants for icons
  const firstSamplePersonIcon = 'reference_profile_guardian';
  const secondSamplePersonIcon = 'reference_profile_persuader';
  const baseClassName = 'RelationshipSample';

  return (
    <WpContainer className={`${baseClassName}`}>
      <WpContainerBody className={`${baseClassName}__body`} padding={32}>
        <WpText tag="p" variant="bodyLg" bold noMargin>
          See how to work best with a co-worker.
        </WpText>
        <WpText tag="p" color="gray-600" variant="bodyMd">
          In this sample relationship, Ana and Kay have very different behavioral drives. Use PI Inspire to understand
          where these two co-workers align or differ, so they can avoid conflict and work better together.&nbsp;&nbsp;
          <WpLink href={ExternalLinksConstants.learn_more_about_inspire} onClick={trackLearnMoreInspireBasicsClick}>
            <WpIcon name="external-link" />
            Learn More
          </WpLink>
        </WpText>

        <div className={`${baseClassName}__details-content`}>
          <div className={`${baseClassName}__ba-profile ${baseClassName}__ba-profile--left`}>
            <RelationshipSamplePerson
              icon={firstSamplePersonIcon}
              personFirstName="Kay"
              personLastName="Richards"
              referencePatternName={ReferencePatternName.guardian}
              referenceProfileDescription="Kay is a Guardian."
            />
          </div>
          <div className={`${baseClassName}__combined-ba-pattern`}>
            <RelationshipSampleGraph />
          </div>
          <div className={`${baseClassName}__ba-profile ${baseClassName}__ba-profile--right`}>
            <RelationshipSamplePerson
              icon={secondSamplePersonIcon}
              personFirstName="Ana"
              personLastName="Ramirez"
              referencePatternName={ReferencePatternName.persuader}
              referenceProfileDescription="Ana is a Persuader."
            />
          </div>
        </div>
        <WpDivider />
        <div className={`${baseClassName}__inspire-nav-btn`}>
          <WpButton size="md" dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}>
            See How It Works
          </WpButton>
        </div>
      </WpContainerBody>
    </WpContainer>
  );
};

export default RelationshipSample;
